import { render, staticRenderFns } from "./ContractsForm.vue?vue&type=template&id=6da612cd"
import script from "./ContractsForm.vue?vue&type=script&lang=js"
export * from "./ContractsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports